module.exports = __webpack_public_path__ + "img/Res-Icon-1.694a24f.png";